import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'ar_SA', // set default locale
  fallbackLocale: 'ar_SA',
  messages: {}, // locale is empty and will be fetched later
})

export default i18n
